export default "__VITE_ASSET__BdpUWL3B__"